module.exports = __webpack_public_path__ + "img/explorer.2ded27cc.png";